import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { cuocThaoLuanApi } from "../../../api/cuocThaoLuanApi";
import { IBaseResponeModel } from '../../../models/response/base-response';
import { ICuocThaoLuanComment } from "../../../models/response/cuoc-thao-luan/ICuocThaoLuanComment";
import { actions } from '../../actions/actionsWrapper';
import { eCuocThaoLuanActionTypeIds, ICuocThaoLuanActionTypes } from './../../action-types/cuoc-thao-luan/ICuocThaoLuanActionTypes';
import { ICuocThaoLuanReaction } from "../../../models/response/cuoc-thao-luan/ICuocThaoLuanReaction";


export function* cuocThaoLuanSaga(): any {
    yield takeLatest(eCuocThaoLuanActionTypeIds.LOAD_INFO_START, loadInfoWorker)
    yield takeLatest(eCuocThaoLuanActionTypeIds.LOAD_COMMENT_START, loadCommentWorker)
    yield takeLatest(eCuocThaoLuanActionTypeIds.LOAD_REACTION_START, loadReactionWorker)
    yield takeEvery(eCuocThaoLuanActionTypeIds.ADD_COMMENT_START, addCommentWorker)
    yield takeEvery(eCuocThaoLuanActionTypeIds.REMOVE_COMMENT_START, removeCommentWorker)
    yield takeEvery(eCuocThaoLuanActionTypeIds.ADD_REACTION_START, addReactionWorker)
    yield takeEvery(eCuocThaoLuanActionTypeIds.REMOVE_REACTION_START, removeReactionWorker)
}

function* loadInfoWorker(action: ICuocThaoLuanActionTypes): any {
    const res: IBaseResponeModel = yield call(cuocThaoLuanApi.loadStart, action.payload as number)
    if (res.is_success) {
        yield put(actions.cuocThaoLuan.LOAD_INFO_SUCCESS(res.data))
    } else {
        yield put(actions.cuocThaoLuan.LOAD_INFO_ERROR(res.message ?? ""))
    }
}

function* loadCommentWorker(action: ICuocThaoLuanActionTypes): any {
    const res: IBaseResponeModel = yield call(cuocThaoLuanApi.loadComment, action.payload as number)
    if (res.is_success) {
        yield put(actions.cuocThaoLuan.LOAD_COMMENT_SUCCESS(res.data))
    } else {
        yield put(actions.cuocThaoLuan.LOAD_COMMENT_ERROR(res.message ?? ""))
    }
}

function* loadReactionWorker(action: ICuocThaoLuanActionTypes): any {
    const res: IBaseResponeModel = yield call(cuocThaoLuanApi.loadReaction, action.payload as number)
    if (res.is_success) {
        yield put(actions.cuocThaoLuan.LOAD_REACTION_SUCCESS(res.data))
    } else {
        yield put(actions.cuocThaoLuan.LOAD_REACTION_ERROR(res.message ?? ""))
    }
}

function* addCommentWorker(action: ICuocThaoLuanActionTypes): any {
    const res: IBaseResponeModel = yield call(cuocThaoLuanApi.addComment, action.payload as ICuocThaoLuanComment)
    if (res.is_success) {
        yield put(actions.cuocThaoLuan.ADD_COMMENT_SUCCESS(res.data))
    } else {
        yield put(actions.cuocThaoLuan.ADD_COMMENT_ERROR(res.message ?? ""))
    }
}

function* removeCommentWorker(action: ICuocThaoLuanActionTypes): any {
    const res: IBaseResponeModel = yield call(cuocThaoLuanApi.removeComment, action.payload as number)
    if (res.is_success) {
        yield put(actions.cuocThaoLuan.REMOVE_COMMENT_SUCCESS(res.data))
    } else {
        yield put(actions.cuocThaoLuan.REMOVE_COMMENT_ERROR(res.message ?? ""))
    }
}

function* addReactionWorker(action: ICuocThaoLuanActionTypes): any {
    const res: IBaseResponeModel = yield call(cuocThaoLuanApi.addReaction, action.payload as ICuocThaoLuanReaction)
    if (res.is_success) {
        yield put(actions.cuocThaoLuan.ADD_REACTION_SUCCESS(res.data))
    } else {
        yield put(actions.cuocThaoLuan.ADD_REACTION_ERROR(res.message ?? ""))
    }
}

function* removeReactionWorker(action: ICuocThaoLuanActionTypes): any {
    const res: IBaseResponeModel = yield call(cuocThaoLuanApi.removeReation, action.payload as number)
    if (res.is_success) {
        yield put(actions.cuocThaoLuan.REMOVE_REACTION_START(res.data))
    } else {
        yield put(actions.cuocThaoLuan.REMOVE_REACTION_ERROR(res.message ?? ""))
    }
}
